export default __webpack_public_path__ + "static/media/2341.e33e8185.png";